/**
 * SchedulesSystemHelp container selectors
 *
 * @author Rafael Guedes <rguedes@ubiwhere.com>
 *
 */

import { RootState } from 'store/rootSlices';

export const getUcs = (state: RootState) => state.Schedules.ucs;
